module.exports = __webpack_public_path__ + "img/card31.ab69f382.png";